function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.ImmersiveReader = t() : e.ImmersiveReader = t();
}(self, function () {
  return function () {
    "use strict";

    var e = {
      150: function _(e, t) {
        var r;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.ErrorCode = void 0, (r = t.ErrorCode || (t.ErrorCode = {})).BadArgument = "BadArgument", r.Timeout = "Timeout", r.TokenExpired = "TokenExpired", r.Throttled = "Throttled", r.ServerError = "ServerError", r.InvalidSubdomain = "InvalidSubdomain";
      },
      925: function _(e, t, r) {
        var n = this && this.__assign || function () {
          return n = Object.assign || function (e) {
            for (var t, r = 1, n = arguments.length; r < n; r++) {
              for (var i in t = arguments[r]) {
                Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
              }
            }

            return e;
          }, n.apply(this, arguments);
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.isValidSubdomain = t.close = t.launchAsync = void 0;
        var i = r(411),
            a = r(150),
            o = "ImmersiveReader-Preferences:",
            s = "ImmersiveReader-LaunchResponse:",
            d = {};
        d[a.ErrorCode.TokenExpired] = "The access token supplied is expired.", d[a.ErrorCode.Throttled] = "You have exceeded your quota.", d[a.ErrorCode.ServerError] = "An error occurred when calling the server to process the text.", d[a.ErrorCode.InvalidSubdomain] = "The subdomain supplied is invalid.";
        var l = !1;

        function u(e) {
          return !!e && new RegExp("^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])$").test(e);
        }

        t.launchAsync = function (e, t, r, c) {
          return l ? Promise.reject("Immersive Reader is already launching") : new Promise(function (m, p) {
            if (e) {
              if (r) {
                if (r.chunks) {
                  if (r.chunks.length) {
                    if (u(t) || c && c.customDomain) {
                      l = !0;
                      var h = Date.now();
                      (c = n({
                        uiZIndex: 1e3,
                        timeout: 15e3,
                        useWebview: !1,
                        allowFullscreen: !0,
                        hideExitButton: !1,
                        cookiePolicy: i.CookiePolicy.Disable
                      }, c)).uiZIndex && "number" == typeof c.uiZIndex || (c.uiZIndex = 1e3);
                      var v = null,
                          b = document.createElement("div"),
                          g = c.useWebview ? document.createElement("webview") : document.createElement("iframe");
                      g.allow = "autoplay", g.title = "Immersive Reader Frame", g.setAttribute("aria-modal", "true");
                      var f = document.createElement("style");
                      f.innerHTML = "body{height:100%;overflow:hidden;}";

                      var y = function y() {
                        v && (window.clearTimeout(v), v = null);
                      },
                          k = c.parent && document.contains(c.parent) ? c.parent : document.body,
                          w = function w() {
                        k.contains(b) && k.removeChild(b), window.removeEventListener("message", x), y(), f.parentNode && f.parentNode.removeChild(f);
                      },
                          E = function E() {
                        if (w(), l = !1, c.onExit) try {
                          c.onExit();
                        } catch (e) {}
                      };

                      w();

                      var x = function x(n) {
                        if (n && n.data && "string" == typeof n.data) if ("ImmersiveReader-ReadyForContent" === n.data) {
                          y();
                          var i = {
                            cogSvcsAccessToken: e,
                            cogSvcsSubdomain: t,
                            request: r,
                            launchToPostMessageSentDurationInMs: Date.now() - h,
                            disableFirstRun: c.disableFirstRun,
                            readAloudOptions: c.readAloudOptions,
                            translationOptions: c.translationOptions,
                            displayOptions: c.displayOptions,
                            sendPreferences: !!c.onPreferencesChanged,
                            preferences: c.preferences,
                            disableTranslation: c.disableTranslation,
                            disableGrammar: c.disableGrammar,
                            disableLanguageDetection: c.disableLanguageDetection
                          };
                          g.contentWindow.postMessage(JSON.stringify({
                            messageType: "Content",
                            messageValue: i
                          }), "*");
                        } else if ("ImmersiveReader-Exit" === n.data) E();else if (n.data.startsWith(s)) {
                          var u = null,
                              v = null,
                              f = null;

                          try {
                            f = JSON.parse(n.data.substring(s.length));
                          } catch (e) {}

                          f && f.success ? u = {
                            container: b,
                            sessionId: f.sessionId,
                            charactersProcessed: f.meteredContentSize
                          } : v = f && !f.success ? {
                            code: f.errorCode,
                            message: d[f.errorCode],
                            sessionId: f.sessionId
                          } : {
                            code: a.ErrorCode.ServerError,
                            message: d[a.ErrorCode.ServerError]
                          }, l = !1, u ? (y(), m(u)) : v && (E(), p(v));
                        } else if (n.data.startsWith(o) && c.onPreferencesChanged && "function" == typeof c.onPreferencesChanged) try {
                          c.onPreferencesChanged(n.data.substring(o.length));
                        } catch (e) {}
                      };

                      window.addEventListener("message", x), v = window.setTimeout(function () {
                        w(), l = !1, p({
                          code: a.ErrorCode.Timeout,
                          message: "Page failed to load after timeout (" + c.timeout + " ms)"
                        });
                      }, c.timeout), c.allowFullscreen && g.setAttribute("allowfullscreen", ""), g.style.cssText = c.parent ? "position: static; width: 100%; height: 100%; left: 0; top: 0; border-width: 0" : "position: static; width: 100vw; height: 100vh; left: 0; top: 0; border-width: 0", c.useWebview && g.addEventListener("loadstop", function () {
                        g.contentWindow.postMessage(JSON.stringify({
                          messageType: "WebviewHost"
                        }), "*");
                      });
                      var C = (c.customDomain ? c.customDomain : "https://" + t + ".cognitiveservices.azure.com/immersivereader/webapp/v1.0/") + "reader?exitCallback=ImmersiveReader-Exit&sdkPlatform=js&sdkVersion=1.2.0";
                      C += "&cookiePolicy=" + (c.cookiePolicy === i.CookiePolicy.Enable ? "enable" : "disable"), c.hideExitButton && (C += "&hideExitButton=true"), c.uiLang && (C += "&omkt=" + c.uiLang), g.src = C, b.style.cssText = c.parent ? "position: relative; width: 100%; height: 100%; border-width: 0; -webkit-perspective: 1px; z-index: " + c.uiZIndex + "; background: white; overflow: hidden" : "position: fixed; width: 100vw; height: 100vh; left: 0; top: 0; border-width: 0; -webkit-perspective: 1px; z-index: " + c.uiZIndex + "; background: white; overflow: hidden", b.appendChild(g), k.appendChild(b), document.head.appendChild(f);
                    } else p({
                      code: a.ErrorCode.InvalidSubdomain,
                      message: d[a.ErrorCode.InvalidSubdomain]
                    });
                  } else p({
                    code: a.ErrorCode.BadArgument,
                    message: "Chunks must not be empty"
                  });
                } else p({
                  code: a.ErrorCode.BadArgument,
                  message: "Chunks must not be null"
                });
              } else p({
                code: a.ErrorCode.BadArgument,
                message: "Content must not be null"
              });
            } else p({
              code: a.ErrorCode.BadArgument,
              message: "Token must not be null"
            });
          });
        }, t.close = function () {
          window.postMessage("ImmersiveReader-Exit", "*");
        }, t.isValidSubdomain = u;
      },
      411: function _(e, t) {
        var r, n;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.ThemeOption = t.CookiePolicy = void 0, (n = t.CookiePolicy || (t.CookiePolicy = {}))[n.Disable = 0] = "Disable", n[n.Enable = 1] = "Enable", (r = t.ThemeOption || (t.ThemeOption = {}))[r.Light = 0] = "Light", r[r.Dark = 1] = "Dark";
      },
      848: function _(e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.renderButtons = void 0;
        var r = "data-locale",
            n = {
          af: "Indompelende leser",
          am: "በህያው ስሜት ፈጣሪ ዕይታ አንባቢ",
          ar: "القارئ الشامل",
          as: "ইমাৰচিভ ৰিডাৰ",
          az: "İmmersiv Oxuyucu",
          be: "Імерсіўны чытальнік",
          bg: "Концентриран четец",
          bn: "মনোগ্রাহী পাঠক",
          "bn-bd": "ইমার্সিভ পাঠক",
          bs: "Koncentrirani čitalac",
          ca: "Lector immersiu",
          cs: "Asistivní čtečka",
          "cy-gb": "Darllenydd Ymdrwythol",
          da: "Forenklet læser",
          de: "Plastischer Reader",
          el: "Προηγμένο πρόγραμμα ανάγνωσης",
          en: "Immersive Reader",
          es: "Lector inmersivo",
          et: "Süvaluger",
          eu: "Irakurgailu murgiltzailea",
          fa: "خواننده همه‌جانبه",
          fi: "Syventävä lukuohjelma",
          fil: "Immersive Reader",
          fr: "Lecteur immersif",
          "ga-ie": "Léitheoir tumthach",
          gd: "An leughadair ùr-nòsach",
          gl: "Lector avanzado",
          gu: "ઇમર્સિવ રીડર",
          ha: "Mai karatu Mai barbazawa",
          he: "תצוגת קריאה מודרנית",
          hi: "इमर्सिव रीडर",
          hr: "Stopljeni čitač",
          hu: "Modern olvasó",
          hy: "Խորասուզված ընթերցիչ",
          id: "Pembaca Imersif",
          ig: "Ọgụụ Kenzipụtara",
          is: "Aðgengilegt lestrarumhverfi",
          it: "Strumento di lettura immersiva",
          ja: "イマーシブ リーダー",
          ka: "იმერსიული წამკითხველი",
          kk: "Иммерсивті оқу құралы",
          km: "កម្មវិធីអានពណ៌រំលេចនៅលើអេក្រង់",
          kn: "ಇಮ್ಮರ್ಸಿವ್ ಓದುಗ",
          ko: "몰입형 리더",
          kok: "तंद्री लागिल्लो वाचक",
          "ku-arab": "خوێنەری پڕ",
          ky: "Курчаган Окугуч",
          lb: "Immersive Reader",
          lo: "ຕົວອ່ານອິມເມີສີບ",
          lt: "Įtraukianti skaitytuvė",
          lv: "Tīrskata lasītājs",
          mi: "Pūpānui Rumaki",
          mk: "Сеопфатен читач",
          ml: "ഇമ്മേഴ്‌സീവ് റീഡർ",
          mn: "Идэвхтэй уншигч",
          mr: "इमर्सिव्ह वाचक",
          ms: "Pembaca Imersif",
          mt: "Qarrej Immersiv",
          ne: "इमेर्सिभ रिडर",
          nl: "Insluitende lezer",
          "nn-no": "Engasjerande lesar",
          no: "Engasjerende leser",
          nso: "Go Bala ka Mongwalo o Mokoto",
          or: "ଇମରସିଭ୍ ରିଡର୍",
          pa: "ਇਮਰਸਿਵ ਰੀਡਰ",
          "pa-arab": "گھیرن آلا مطالعہ کار",
          pl: "Czytnik immersyjny",
          prs: "خواننده نمایش",
          pt: "Leitura Avançada",
          quc: "Nim ucholajil sik'inel uwach",
          quz: "Wankisqa Ñawiq",
          ro: "Immersive Reader",
          ru: "Иммерсивное средство чтения",
          rw: "Insakazasoma",
          sd: "امرسو ريڊر",
          si: "ගිලෙන සුළු කියවනය",
          sk: "Imerzná čítačka",
          sl: "Potopni bralnik",
          sq: "Lexuesi kredhës",
          "sr-cyrl-ba": "Концентрисани читалац",
          "sr-cyrl-rs": "Концентрисани читалац",
          "sr-latn-rs": "Koncentrisani čitalac",
          sv: "Avancerad läsare",
          sw: "Kisomaji cha Kuzamisha",
          ta: "அற்புதமான ரீடர்",
          te: "మంత్రముగ్ధులను చేసే పఠన సాధనం",
          "tg-cyrl-tj": "Хонандаи фарогир",
          th: "โปรแกรมช่วยอ่าน",
          ti: "ኣንባቢ ሕሉው ስምዒት ፈጣሪ",
          tk: "Giňişleýin okaýjy",
          tn: "Sebadi sa Imesife",
          tr: "Tam Ekran Okuyucu",
          tt: "Чолгап алучы уку чарасы",
          "ug-cn": "چۆكمە ئوقۇغۇچ",
          uk: "Занурення в текст",
          ur: "امرسیو مطالعہ کار",
          uz: "Immersiv mutolaa vositasi",
          vi: "Trình đọc Chân thực",
          wo: "Jàngukaay bu Rafet",
          xh: "Isifundi Esikhulu",
          yo: "Ìwò Alámùtán",
          zh: "沉浸式阅读器",
          "zh-hant": "沈浸式閱讀程式",
          zu: "Isifundi Sokuzizwisa"
        };

        function i(e) {
          var t = document.createElement("img");
          t.src = "https://ircdname.azureedge.net/permanent-static-resources/immersive-reader-icon.svg";
          var n = e.getAttribute("data-icon-px-size") || "20";
          t.style.height = t.style.width = n + "px", t.style.verticalAlign = "middle", t.style.marginTop = "-2px";
          var i = e.getAttribute(r) || "en";
          t.alt = s(i), e.appendChild(t);
        }

        function a(e) {
          var t = document.createElement("span");
          t.style.marginLeft = "8px", e.appendChild(t);
        }

        function o(e) {
          var t = document.createElement("span"),
              n = e.getAttribute(r) || "en";
          t.textContent = s(n), e.appendChild(t);
        }

        function s(e) {
          return e = e.toLowerCase(), n[e] ? n[e] : "zh-hk" === e || "zh-mo" === e || "zh-tw" === e ? n["zh-hant"] : (e = e.substring(0, e.lastIndexOf("-")), n[e] ? n[e] : (e = e.substring(0, e.lastIndexOf("-")), n[e] ? n[e] : n.en));
        }

        t.renderButtons = function (e) {
          var t = document.createElement("style");
          t.innerHTML = ".immersive-reader-button{cursor:pointer;display:inline-block;padding:5px;} .immersive-reader-button:hover{background:rgba(0,0,0,.05);border-radius:2px", document.head.appendChild(t);
          var n = [].slice.call(document.getElementsByClassName("immersive-reader-button"));
          e && e.elements && (n = e.elements);

          for (var d = 0, l = n; d < l.length; d++) {
            var u = l[d];
            u.setAttribute("role", "button");
            var c = u.getAttribute(r) || "en";

            switch (u.setAttribute("aria-label", s(c)), u.textContent = "", u.getAttribute("data-button-style") || "icon") {
              case "icon":
                i(u);
                break;

              case "text":
                o(u);
                break;

              case "iconAndText":
                i(u), a(u), o(u);
            }
          }
        };
      }
    },
        t = {};

    function r(n) {
      var i = t[n];
      if (void 0 !== i) return i.exports;
      var a = t[n] = {
        exports: {}
      };
      return e[n].call(a.exports, a, a.exports, r), a.exports;
    }

    var n = {};
    return function () {
      var e = n;
      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.CookiePolicy = e.launchAsync = e.close = e.renderButtons = void 0;
      var t = r(848);
      Object.defineProperty(e, "renderButtons", {
        enumerable: !0,
        get: function get() {
          return t.renderButtons;
        }
      });
      var i = r(925);
      Object.defineProperty(e, "close", {
        enumerable: !0,
        get: function get() {
          return i.close;
        }
      }), Object.defineProperty(e, "launchAsync", {
        enumerable: !0,
        get: function get() {
          return i.launchAsync;
        }
      });
      var a = r(411);
      Object.defineProperty(e, "CookiePolicy", {
        enumerable: !0,
        get: function get() {
          return a.CookiePolicy;
        }
      }), "undefined" != typeof window && window.addEventListener("load", function () {
        var e;
        window.hasOwnProperty("Promise") || ("https://ircdname.azureedge.net/permanent-static-resources/promise-polyfill.min.js", (e = document.createElement("script")).src = "https://ircdname.azureedge.net/permanent-static-resources/promise-polyfill.min.js", document.head.appendChild(e)), t.renderButtons();
      });
    }(), n;
  }();
});